"use client";

import z from "zod";

import type { UseRequestQueryProps } from "../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../request/hooks/useRequestQuery";
import { keyMeShowStudentLabel } from "./keyMeShowStudentLabel";

export type UseRequestMeShowStudentLabelProps = UseRequestQueryProps;

export const useRequestMeShowStudentLabel = ({
  ...props
}: UseRequestMeShowStudentLabelProps = {}) => ({
  query: useRequestQuery({
    ...props,
    queryFnRequestProps: {
      schema: z.boolean(),
      urlBackendPath: "/me/show-student-label",
    },
    queryKey: keyMeShowStudentLabel(),
  }),
});
